import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { StingrayCommonModule } from '@modules/common/common.module';
import { NavigationModule } from '@modules/navigation/navigation.module';
import { ROUTES } from '@modules/routing/routes';
import { StingrayRouteReuseStrategy } from '@modules/routing/services/stingray-route-reuse-strategy';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        StingrayCommonModule,
        NavigationModule,
        RouterModule.forRoot(ROUTES)
    ],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: StingrayRouteReuseStrategy
        }
    ]
})
export class StingrayRoutingModule {
}
